import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

function getVisitorId() {
  let id = localStorage.getItem('_skye_vid');
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem('_skye_vid', id);
  }
  return id;
}

function getSessionId() {
  let id = sessionStorage.getItem('_skye_sid');
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem('_skye_sid', id);
  }
  return id;
}

function sendEvent(eventType, page, metadata) {
  const payload = {
    event_type: eventType,
    page,
    referrer: document.referrer || '',
    screen_width: window.innerWidth,
    screen_height: window.innerHeight,
    visitor_id: getVisitorId(),
    session_id: getSessionId(),
    metadata: metadata || null,
  };
  // Use sendBeacon for reliability, fall back to fetch
  const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
  const sent = navigator.sendBeacon?.(`${API}/api/analytics/track`, blob);
  if (!sent) {
    fetch(`${API}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  }
}

// Expose globally so other components can fire custom events
window.__skyeTrack = sendEvent;

function sendHeartbeat(page) {
  const payload = {
    visitor_id: getVisitorId(),
    session_id: getSessionId(),
    page,
  };
  const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
  const sent = navigator.sendBeacon?.(`${API}/api/analytics/heartbeat`, blob);
  if (!sent) {
    fetch(`${API}/api/analytics/heartbeat`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  }
}

export default function AnalyticsTracker() {
  const { pathname } = useLocation();
  const prev = useRef(null);
  const heartbeatRef = useRef(null);

  useEffect(() => {
    if (pathname === prev.current) return;
    prev.current = pathname;
    if (pathname.startsWith('/admin')) return;
    sendEvent('page_view', pathname);
  }, [pathname]);

  // Heartbeat every 30s for live visitor tracking
  useEffect(() => {
    if (pathname.startsWith('/admin')) return;

    // Send initial heartbeat
    sendHeartbeat(pathname);

    heartbeatRef.current = setInterval(() => {
      sendHeartbeat(pathname);
    }, 30000);

    return () => clearInterval(heartbeatRef.current);
  }, [pathname]);

  return null;
}
